module.exports = __webpack_public_path__ + "static/media/acquisitions-incorporated.9ce1a633.svg";